export const RowSkeleton = () => {
  return (
    <div data-testid="row-skeleton" className="flex animate-pulse space-x-4">
      <div className="flex-1 space-y-4 py-2">
        <div className="h-3 w-3/4 rounded bg-gray-300" />
      </div>
    </div>
  );
};
